import { FC } from 'react';
import { Service } from './Service/Service';
import { useFetchBanners } from '@/hooks/api/banner/useFetchBanners';
import { useEffectiveAffiliateId } from '@/hooks/useEffectiveAffiliateId';

type ServicePageProps = {
  id: string;
  categoryName?: string;
};

export const ServicePage: FC<ServicePageProps> = ({ id, categoryName }) => {
  const numericId = Number(id);
  // カテゴリ一覧と同じ「ショッピング先」の法人でバナーを出し分ける
  const affiliate_id = useEffectiveAffiliateId();

  const { banners } = useFetchBanners({
    m_mt_service_category_id: numericId,
    m_affiliate_id: affiliate_id,
  });

  return (
    <Service id={numericId} categoryName={categoryName} banners={banners} />
  );
};
